import { useEffect, useState } from "react";
import { upsertTag, uuidMapping } from "../helper";

export const useAgeFilter = (talentFilter, talentFilterTags, controlledValues) => {
  const [ageValues, setAgeValues] = useState(
    controlledValues ?? { start_value: 0, end_value: 0 }
  );

  useEffect(() => {
    if (controlledValues !== undefined) return;

    const ageAttr = talentFilter?.person_attributes?.find(
      attr => attr?.person_attribute_uuid === uuidMapping.age
    );
    if (ageAttr) {
      setAgeValues({
        start_value: ageAttr.start_value,
        end_value: ageAttr.end_value,
      });
    } else {
      clearAge();
    }
  }, [talentFilter]);

  useEffect(() => {
    if (controlledValues !== undefined) return;

    const ageExists = talentFilter?.person_attributes?.some(
      attr => attr?.person_attribute_uuid === uuidMapping.age
    );
    if (!ageExists) clearAge();
  }, [talentFilter]);

  useEffect(() => {
    if (controlledValues === undefined) return;
    setAgeValues(controlledValues);
  }, [controlledValues?.start_value, controlledValues?.end_value]);

  const clearAge = () => setAgeValues({ start_value: 0, end_value: 0 });

  const isDisabled =
    !ageValues.start_value ||
    !ageValues.end_value ||
    ageValues.end_value <= ageValues.start_value;

  const buildAgeFilter = () => {
    if (isDisabled) return null;

    const agePayload = {
      person_attribute_uuid: uuidMapping.age,
      contains: false,
      has_all_in_list: false,
      list: null,
      start_value: parseInt(ageValues.start_value),
      end_value: parseInt(ageValues.end_value),
    };

    const tags = upsertTag(talentFilterTags, uuidMapping.age, ageValues);

    return { attribute: agePayload, tags };
  };

  return {
    ageValues,
    setMin: val => setAgeValues(age => ({ ...age, start_value: val })),
    setMax: val => setAgeValues(age => ({ ...age, end_value: val })),
    isDisabled,
    buildAgeFilter,
    clearAge,
  };
};